import { render, staticRenderFns } from "./DealsSidebar.vue?vue&type=template&id=5dbec1f5"
import script from "./DealsSidebar.vue?vue&type=script&lang=js"
export * from "./DealsSidebar.vue?vue&type=script&lang=js"
import style0 from "./DealsSidebar.vue?vue&type=style&index=0&id=5dbec1f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports